export enum CARD_VARIANT {
  OUTLINED = 'outlined',
  ELEVATED = 'elevated',
  FLAT = 'flat',
}
export enum CARD_PADDING {
  NONE = 'none',
  COMPACT = 'compact',
  DEFAULT = 'default',
  SPACIOUS = 'spacious',
}
